export default __webpack_public_path__ + "static/media/e-commerce-3406613_1920.4d705c28.jpg";